/*** Dependencies ***/
import React, {FC} from 'react'

/*** Components ***/
import NotificationItem from './NotificationItem'

type props = {
  notifications: any
}

const Notifications: FC<props> = ({notifications}) => {
  return (
    <div className='card'>
      <div className='card-header border-0'>
        <h3 className='card-title fw-bolder text-dark'>Görev Bildirimleri</h3>
      </div>
      <div className='card-body pt-0'>
        {notifications.map((notification: any, index: number) => (
          <NotificationItem key={index} {...notification} />
        ))}
      </div>
    </div>
  )
}

export default Notifications
